import React from 'react';

export const ButtonLoader: React.FC = () => (
  <div className="d-flex py-2 justify-content-center">
    <div className="spinner-grow spinner-grow-sm" role="status" />
    <div className="spinner-grow spinner-grow-sm mx-2" role="status" />
    <div className="spinner-grow spinner-grow-sm" role="status" />
  </div>
);
